<template>
  <div class="d-flex align-items-center">
    <label for="gcn-exemptions-toggle" class="form-label mb-0 me-3">Enable GCN Drug Exemptions</label>
    <div class="switch" data-animated="true">
      <input
        id="gcn-exemptions-toggle"
        ref="checkbox"
        type="checkbox"
        :checked="enabled"
        :disabled="!canEdit || loading"
      />
    </div>
    <div v-if="loading" class="spinner-border spinner-border-sm ms-2" role="status">
      <span class="visually-hidden">Saving...</span>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    pmpId: {
      type: Number,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    exemptionsEnabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['error', 'success'],
  data() {
    return {
      enabled: this.exemptionsEnabled,
      loading: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      const $checkbox = $(this.$refs.checkbox);
      $checkbox.bootstrapSwitch();
      $checkbox.on('switchChange.bootstrapSwitch', (event, state) => {
        this.toggle(state);
      });
    });
  },
  beforeUnmount() {
    const $checkbox = $(this.$refs.checkbox);
    $checkbox.off('switchChange.bootstrapSwitch');
    $checkbox.bootstrapSwitch('destroy');
  },
  methods: {
    async toggle(newState) {
      this.loading = true;

      try {
        const response = await axios.patch('/pmps/miscellaneous/update_pmp_settings.json', {
          pmp: {
            pmp_id: this.pmpId,
            clinical_formulation_exemptions_enabled: newState ? '1' : '0'
          }
        });
        this.$emit('success', response?.data?.message || 'PMP Settings saved successfully.');

        this.enabled = newState;
      } catch (err) {
        $(this.$refs.checkbox).bootstrapSwitch('state', !newState, true);
        this.$emit('error', err?.response?.data?.error || 'Failed to update setting. Please try again.');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
